<div class="filter-box grid align-center">
  <div class="xs-12 m-2 title">{{'form-filter.by-form' | i18next}}</div>
  <div class="xs-12 m-10">
    <div class="form-type-filter scroll-h">
      <div class="form-type"
           (click)="handleShapeTypeSelected('rund')"
           [ngClass]="{'selected': shapeSelected.rund}"
      >
        <div class="form-type-img">
          <img src="../../../../assets/img/form_types/round.svg">
          <img class="checkmark" src="./assets/img/checkmark-circle.svg">
        </div>
        {{'form-filter.round' | i18next}}
      </div>
      <div class="form-type"
           (click)="handleShapeTypeSelected('oval')"
           [ngClass]="{'selected': shapeSelected.oval}"
      >
        <div class="form-type-img">
          <img src="../../../../assets/img/form_types/oval.svg">
          <img class="checkmark" src="./assets/img/checkmark-circle.svg">
        </div>
        {{'form-filter.oval' | i18next}}
      </div>
      <div class="form-type"
           (click)="handleShapeTypeSelected('quadratisch')"
           [ngClass]="{'selected': shapeSelected.quadratisch}"
      >
        <div class="form-type-img">
          <img src="../../../../assets/img/form_types/square.svg">
          <img class="checkmark" src="./assets/img/checkmark-circle.svg">
        </div>
        {{'form-filter.square' | i18next}}
      </div>
      <div class="form-type"
           (click)="handleShapeTypeSelected('rechteckig')"
           [ngClass]="{'selected': shapeSelected.rechteckig}"
      >
        <div class="form-type-img">
          <img src="../../../../assets/img/form_types/rectangle.svg">
          <img class="checkmark" src="./assets/img/checkmark-circle.svg">
        </div>
        {{'form-filter.rectangular' | i18next}}
      </div>
      <div class="form-type"
           (click)="handleShapeTypeSelected('organisch')"
           [ngClass]="{'selected': shapeSelected.organisch}"
      >
        <div class="form-type-img">
          <img src="../../../../assets/img/form_types/organic.svg">
          <img class="checkmark" src="./assets/img/checkmark-circle.svg">
        </div>
        {{'form-filter.organic' | i18next}}
      </div>
    </div>
  </div>
</div>
